const Vue = require('vue')

Vue.component('property-stacked-prices', require('components/property/StackedPrices.vue'))



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/property-stacked-prices.js